var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('app-supervision-activity-header',[_vm._v("Lista de Chequeo")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('app-contact-report-form',{attrs:{"redirect":"supervisionIndexPage","client-id":_vm.supervisionClient.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }